exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-section[data-v-40ad4030] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.file-info .file-name[data-v-40ad4030] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-size: 14px;\n  color: #303133;\n}\n.file-info .user-count[data-v-40ad4030] {\n  font-size: 14px;\n  color: #606266;\n}\n.selected-tags[data-v-40ad4030] {\n  margin-top: 12px;\n  min-height: 40px;\n}\n", ""]);

// exports
